import * as globals from "./globals";
import type { OctopusTheme } from "./OctopusTheme";
export const slateLightTheme: OctopusTheme = {
    "colorAvatarBackgroundActionDefault": globals["colorScales"]["green"]["200"],
    "colorAvatarBackgroundActionHover": globals["colorScales"]["green"]["300"],
    "colorAvatarBackgroundImageDefault": globals["colorScales"]["slate"]["100"],
    "colorAvatarBackgroundImageHover": globals["colorScales"]["slate"]["300"],
    "colorAvatarBackgroundPageDefault": globals["colorScales"]["blue"]["200"],
    "colorAvatarBackgroundPageHover": globals["colorScales"]["blue"]["300"],
    "colorAvatarBackgroundProjectDefault": globals["colorScales"]["slate"]["500"],
    "colorAvatarBackgroundProjectHover": globals["colorScales"]["slate"]["600"],
    "colorAvatarBackgroundSpaceDefault": globals["colorScales"]["slate"]["500"],
    "colorAvatarBackgroundSpaceHover": globals["colorScales"]["slate"]["600"],
    "colorAvatarBackgroundTemplateDefault": globals["colorScales"]["slate"]["100"],
    "colorAvatarBackgroundTemplateHover": globals["colorScales"]["slate"]["200"],
    "colorAvatarBackgroundTenantDefault": globals["colorScales"]["white"],
    "colorAvatarBackgroundTenantHover": globals["colorScales"]["slate"]["100"],
    "colorAvatarBackgroundUserDefault": globals["colorScales"]["slate"]["500"],
    "colorAvatarBackgroundUserHover": globals["colorScales"]["slate"]["600"],
    "colorAvatarIconAction": globals["colorScales"]["green"]["700"],
    "colorAvatarIconPage": globals["colorScales"]["blue"]["700"],
    "colorAvatarIconPrimary": globals["colorScales"]["white"],
    "colorAvatarIconSecondary": globals["colorScales"]["slate"]["800"],
    "colorAvatarStackBackgroundHover": globals["colorScales"]["slate"]["200"],
    "colorAvatarStackBorder": globals["colorScales"]["white"],
    "colorAvatarText": globals["colorScales"]["white"],
    "colorBackgroundBold": globals["colorScales"]["white"],
    "colorBackgroundDanger": globals["colorScales"]["red"]["100"],
    "colorBackgroundDefault": "rgb(from #FFFFFF r g b / 0)",
    "colorBackgroundDisabled": globals["colorScales"]["slate"]["200"],
    "colorBackgroundFeature": globals["colorScales"]["purple"]["100"],
    "colorBackgroundHover": globals["colorScales"]["slate"]["200"],
    "colorBackgroundInfo": globals["colorScales"]["blue"]["100"],
    "colorBackgroundInverseDanger": globals["colorScales"]["red"]["500"],
    "colorBackgroundInverseFeature": globals["colorScales"]["purple"]["600"],
    "colorBackgroundInverseInfo": globals["colorScales"]["blue"]["500"],
    "colorBackgroundInverseNeutral": globals["colorScales"]["slate"]["600"],
    "colorBackgroundInverseNeutralQuiet": globals["colorScales"]["slate"]["200"],
    "colorBackgroundInversePrimary": globals["colorScales"]["slate"]["900"],
    "colorBackgroundInverseSecondary": globals["colorScales"]["slate"]["700"],
    "colorBackgroundInverseSuccess": globals["colorScales"]["green"]["500"],
    "colorBackgroundInverseWarning": globals["colorScales"]["yellow"]["500"],
    "colorBackgroundNeutral": globals["colorScales"]["slate"]["100"],
    "colorBackgroundPrimaryDefault": globals["colorScales"]["white"],
    "colorBackgroundPrimaryHover": globals["colorScales"]["slate"]["100"],
    "colorBackgroundPrimaryPressed": globals["colorScales"]["slate"]["200"],
    "colorBackgroundPrimaryTransparent": "rgb(from #FFFFFF r g b / 0.72)",
    "colorBackgroundQuartaryDefault": globals["colorScales"]["white"],
    "colorBackgroundQuartaryHover": globals["colorScales"]["slate"]["100"],
    "colorBackgroundQuartaryPressed": globals["colorScales"]["slate"]["200"],
    "colorBackgroundSecondaryDefault": globals["colorScales"]["slate"]["100"],
    "colorBackgroundSecondaryHover": globals["colorScales"]["white"],
    "colorBackgroundSecondaryPressed": globals["colorScales"]["slate"]["300"],
    "colorBackgroundSecondaryTransparent": "rgb(from #F5F6F8 r g b / 0.72)",
    "colorBackgroundSelected": globals["colorScales"]["slate"]["900"],
    "colorBackgroundSuccess": globals["colorScales"]["green"]["100"],
    "colorBackgroundTertiary": globals["colorScales"]["slate"]["200"],
    "colorBackgroundWarning": globals["colorScales"]["yellow"]["100"],
    "colorBadgeBoldBackgroundDanger": globals["colorScales"]["red"]["500"],
    "colorBadgeBoldBackgroundFeature": globals["colorScales"]["purple"]["200"],
    "colorBadgeBoldBackgroundInfo": globals["colorScales"]["blue"]["500"],
    "colorBadgeBoldBackgroundInverseNeutral": globals["colorScales"]["slate"]["600"],
    "colorBadgeBoldBackgroundNeutral": globals["colorScales"]["slate"]["200"],
    "colorBadgeBoldBackgroundSuccess": globals["colorScales"]["green"]["500"],
    "colorBadgeBoldBackgroundUpsell": globals["colorScales"]["purple"]["200"],
    "colorBadgeBoldBackgroundWarning": globals["colorScales"]["yellow"]["500"],
    "colorBadgeBoldIconFeature": globals["colorScales"]["purple"]["700"],
    "colorBadgeBoldIconPrimary": globals["colorScales"]["white"],
    "colorBadgeBoldIconSecondary": globals["colorScales"]["black"],
    "colorBadgeBoldIconUpsell": globals["colorScales"]["purple"]["700"],
    "colorBadgeBoldTextFeature": globals["colorScales"]["purple"]["700"],
    "colorBadgeBoldTextPrimary": globals["colorScales"]["white"],
    "colorBadgeBoldTextSecondary": globals["colorScales"]["black"],
    "colorBadgeBoldTextUpsell": globals["colorScales"]["purple"]["700"],
    "colorBadgeSubtleBackgroundDanger": globals["colorScales"]["red"]["100"],
    "colorBadgeSubtleBackgroundFeature": globals["colorScales"]["purple"]["100"],
    "colorBadgeSubtleBackgroundInfo": globals["colorScales"]["blue"]["100"],
    "colorBadgeSubtleBackgroundNeutral": globals["colorScales"]["slate"]["100"],
    "colorBadgeSubtleBackgroundSuccess": globals["colorScales"]["green"]["100"],
    "colorBadgeSubtleBackgroundUpsell": globals["colorScales"]["purple"]["100"],
    "colorBadgeSubtleBackgroundWarning": globals["colorScales"]["yellow"]["100"],
    "colorBadgeSubtleBorderDanger": globals["colorScales"]["red"]["200"],
    "colorBadgeSubtleBorderFeature": globals["colorScales"]["purple"]["200"],
    "colorBadgeSubtleBorderInfo": globals["colorScales"]["blue"]["200"],
    "colorBadgeSubtleBorderNeutral": globals["colorScales"]["slate"]["200"],
    "colorBadgeSubtleBorderSuccess": globals["colorScales"]["green"]["200"],
    "colorBadgeSubtleBorderUpsell": globals["colorScales"]["purple"]["200"],
    "colorBadgeSubtleBorderWarning": globals["colorScales"]["yellow"]["200"],
    "colorBadgeSubtleIconDanger": globals["colorScales"]["red"]["500"],
    "colorBadgeSubtleIconFeature": globals["colorScales"]["purple"]["500"],
    "colorBadgeSubtleIconInfo": globals["colorScales"]["blue"]["500"],
    "colorBadgeSubtleIconNeutral": globals["colorScales"]["slate"]["600"],
    "colorBadgeSubtleIconSuccess": globals["colorScales"]["green"]["500"],
    "colorBadgeSubtleIconUpsell": globals["colorScales"]["purple"]["500"],
    "colorBadgeSubtleIconWarning": globals["colorScales"]["yellow"]["500"],
    "colorBadgeSubtleTextDanger": globals["colorScales"]["red"]["600"],
    "colorBadgeSubtleTextFeature": globals["colorScales"]["purple"]["600"],
    "colorBadgeSubtleTextInfo": globals["colorScales"]["blue"]["600"],
    "colorBadgeSubtleTextNeutral": globals["colorScales"]["slate"]["600"],
    "colorBadgeSubtleTextSuccess": globals["colorScales"]["green"]["600"],
    "colorBadgeSubtleTextUpsell": globals["colorScales"]["purple"]["600"],
    "colorBadgeSubtleTextWarning": globals["colorScales"]["yellow"]["600"],
    "colorBorderBold": globals["colorScales"]["slate"]["500"],
    "colorBorderDanger": globals["colorScales"]["red"]["500"],
    "colorBorderDefault": globals["colorScales"]["slate"]["600"],
    "colorBorderDisabled": globals["colorScales"]["slate"]["300"],
    "colorBorderFeature": globals["colorScales"]["purple"]["500"],
    "colorBorderInfo": globals["colorScales"]["blue"]["500"],
    "colorBorderInversePrimary": globals["colorScales"]["slate"]["700"],
    "colorBorderInverseSecondary": globals["colorScales"]["slate"]["700"],
    "colorBorderLinkDefault": globals["colorScales"]["slate"]["700"],
    "colorBorderLinkHover": globals["colorScales"]["slate"]["900"],
    "colorBorderPrimary": globals["colorScales"]["slate"]["200"],
    "colorBorderSecondary": globals["colorScales"]["slate"]["100"],
    "colorBorderSelected": globals["colorScales"]["slate"]["700"],
    "colorBorderSuccess": globals["colorScales"]["green"]["500"],
    "colorBorderTertiary": globals["colorScales"]["slate"]["300"],
    "colorBorderWarning": globals["colorScales"]["yellow"]["400"],
    "colorButtonBackgroundDestructiveDefault": globals["colorScales"]["red"]["500"],
    "colorButtonBackgroundDestructiveHover": globals["colorScales"]["red"]["600"],
    "colorButtonBackgroundDestructivePressed": globals["colorScales"]["red"]["700"],
    "colorButtonBackgroundDisabled": "rgb(from #DEE1E6 r g b / 0.56)",
    "colorButtonBackgroundGhostDefault": "rgb(from #8A96A7 r g b / 0)",
    "colorButtonBackgroundGhostHover": "rgb(from #8A96A7 r g b / 0.12)",
    "colorButtonBackgroundGhostPressed": "rgb(from #8A96A7 r g b / 0.24)",
    "colorButtonBackgroundLoudDefault": globals["colorScales"]["slate"]["900"],
    "colorButtonBackgroundLoudHover": globals["colorScales"]["slate"]["700"],
    "colorButtonBackgroundLoudPressed": globals["colorScales"]["slate"]["800"],
    "colorButtonBackgroundNeutralDefault": "rgb(from #8A96A7 r g b / 0.12)",
    "colorButtonBackgroundNeutralHover": "rgb(from #8A96A7 r g b / 0.2)",
    "colorButtonBackgroundNeutralPressed": "rgb(from #8A96A7 r g b / 0.32)",
    "colorButtonBackgroundPrimaryDefault": globals["colorScales"]["slate"]["900"],
    "colorButtonBackgroundPrimaryHover": globals["colorScales"]["slate"]["700"],
    "colorButtonBackgroundPrimaryPressed": globals["colorScales"]["slate"]["800"],
    "colorButtonBackgroundQuietDefault": "rgb(from #8A96A7 r g b / 0)",
    "colorButtonBackgroundQuietHover": "rgb(from #8A96A7 r g b / 0.12)",
    "colorButtonBackgroundQuietPressed": "rgb(from #8A96A7 r g b / 0.24)",
    "colorButtonBackgroundSecondaryDefault": "rgb(from #515D70 r g b / 0)",
    "colorButtonBackgroundSecondaryHover": "rgb(from #515D70 r g b / 0.08)",
    "colorButtonBackgroundSecondaryPressed": "rgb(from #515D70 r g b / 0.16)",
    "colorButtonBackgroundTertiaryDefault": "rgb(from #8A96A7 r g b / 0.12)",
    "colorButtonBackgroundTertiaryHover": "rgb(from #8A96A7 r g b / 0.2)",
    "colorButtonBackgroundTertiaryPressed": "rgb(from #8A96A7 r g b / 0.32)",
    "colorButtonBorderDisabled": globals["colorScales"]["slate"]["200"],
    "colorButtonBorderSecondary": globals["colorScales"]["slate"]["600"],
    "colorButtonFocus": globals["colorScales"]["slate"]["600"],
    "colorButtonIconDestructive": globals["colorScales"]["white"],
    "colorButtonIconDisabled": globals["colorScales"]["slate"]["300"],
    "colorButtonIconGhost": globals["colorScales"]["slate"]["800"],
    "colorButtonIconLoud": globals["colorScales"]["white"],
    "colorButtonIconNeutral": globals["colorScales"]["slate"]["600"],
    "colorButtonIconPrimary": globals["colorScales"]["white"],
    "colorButtonIconQuietDefault": "rgb(from #282F38 r g b / 0.55)",
    "colorButtonIconQuietHover": globals["colorScales"]["slate"]["600"],
    "colorButtonIconQuietPressed": globals["colorScales"]["slate"]["600"],
    "colorButtonIconSecondary": globals["colorScales"]["slate"]["800"],
    "colorButtonIconTertiaryDefault": globals["colorScales"]["slate"]["600"],
    "colorButtonIconTertiaryHover": globals["colorScales"]["slate"]["800"],
    "colorButtonIconTertiaryPressed": globals["colorScales"]["slate"]["800"],
    "colorButtonTextDestructive": globals["colorScales"]["white"],
    "colorButtonTextDisabled": globals["colorScales"]["slate"]["400"],
    "colorButtonTextGhost": globals["colorScales"]["slate"]["800"],
    "colorButtonTextLoud": globals["colorScales"]["white"],
    "colorButtonTextNeutral": globals["colorScales"]["slate"]["600"],
    "colorButtonTextPrimary": globals["colorScales"]["white"],
    "colorButtonTextQuietDefault": globals["colorScales"]["slate"]["500"],
    "colorButtonTextQuietHover": globals["colorScales"]["slate"]["600"],
    "colorButtonTextQuietPressed": globals["colorScales"]["slate"]["600"],
    "colorButtonTextSecondary": globals["colorScales"]["slate"]["800"],
    "colorButtonTextTertiaryDefault": globals["colorScales"]["slate"]["600"],
    "colorButtonTextTertiaryHover": globals["colorScales"]["slate"]["800"],
    "colorButtonTextTertiaryPressed": globals["colorScales"]["slate"]["800"],
    "colorCalloutBackgroundDangerDefault": "rgb(from #FFD8D8 r g b / 0.5)",
    "colorCalloutBackgroundDangerHover": "rgb(from #FF9F9F r g b / 0.4)",
    "colorCalloutBackgroundDangerPressed": "rgb(from #FF9F9F r g b / 0.64)",
    "colorCalloutBackgroundFeatureDefault": "rgb(from #E7DEF8 r g b / 0.5)",
    "colorCalloutBackgroundFeatureHover": "rgb(from #C5AEEE r g b / 0.4)",
    "colorCalloutBackgroundFeaturePressed": "rgb(from #C5AEEE r g b / 0.64)",
    "colorCalloutBackgroundInfoDefault": "rgb(from #8A96A7 r g b / 0.16)",
    "colorCalloutBackgroundInfoHover": "rgb(from #8A96A7 r g b / 0.24)",
    "colorCalloutBackgroundInfoPressed": "rgb(from #8A96A7 r g b / 0.32)",
    "colorCalloutBackgroundSuccessDefault": "rgb(from #B8E7D3 r g b / 0.45)",
    "colorCalloutBackgroundSuccessHover": "rgb(from #5ECD9E r g b / 0.4)",
    "colorCalloutBackgroundSuccessPressed": "rgb(from #5ECD9E r g b / 0.64)",
    "colorCalloutBackgroundUpsell": "linear-gradient(95deg, rgb(from #CDE4F7 r g b / 0.5) 0%, rgb(from #E7DEF8 r g b / 0.5) 100%)",
    "colorCalloutBackgroundWarningDefault": "rgb(from #FFDF62 r g b / 0.32)",
    "colorCalloutBackgroundWarningHover": "rgb(from #FFDF62 r g b / 0.4)",
    "colorCalloutBackgroundWarningPressed": "rgb(from #FFDF62 r g b / 0.64)",
    "colorCalloutBorderDanger": globals["colorScales"]["red"]["500"],
    "colorCalloutBorderDefault": globals["colorScales"]["slate"]["500"],
    "colorCalloutBorderFeature": globals["colorScales"]["purple"]["500"],
    "colorCalloutBorderInfo": globals["colorScales"]["slate"]["500"],
    "colorCalloutBorderSuccess": globals["colorScales"]["green"]["500"],
    "colorCalloutBorderUpsell": "linear-gradient(180deg, #87BFEC 0%, #C5AEEE 100%)",
    "colorCalloutBorderWarning": globals["colorScales"]["yellow"]["400"],
    "colorCalloutCodeBackground": globals["colorScales"]["slate"]["500"],
    "colorCalloutIconDanger": globals["colorScales"]["red"]["600"],
    "colorCalloutIconFeature": globals["colorScales"]["purple"]["600"],
    "colorCalloutIconInfo": globals["colorScales"]["slate"]["600"],
    "colorCalloutIconSuccess": globals["colorScales"]["green"]["600"],
    "colorCalloutIconWarning": globals["colorScales"]["yellow"]["600"],
    "colorCalloutTextBody": globals["colorScales"]["slate"]["700"],
    "colorCalloutTextDanger": globals["colorScales"]["red"]["800"],
    "colorCalloutTextFeature": globals["colorScales"]["purple"]["800"],
    "colorCalloutTextInfo": globals["colorScales"]["slate"]["800"],
    "colorCalloutTextSuccess": globals["colorScales"]["green"]["800"],
    "colorCalloutTextWarning": globals["colorScales"]["yellow"]["800"],
    "colorCanvasBackground": globals["colorScales"]["slate"]["100"],
    "colorCanvasPattern": globals["colorScales"]["slate"]["200"],
    "colorCardBackgroundPrimaryDefault": globals["colorScales"]["white"],
    "colorCardBackgroundSecondaryDefault": "rgb(from #FFFFFF r g b / 0)",
    "colorCardBackgroundSecondaryHover": "rgb(from #F5F6F8 r g b / 0.64)",
    "colorCardChartBackgroundDefault": "rgb(from #F5F6F8 r g b / 0.3)",
    "colorCardChartBackgroundHover": "rgb(from #F5F6F8 r g b / 0.5)",
    "colorCarouselBackgroundPrimary": globals["colorScales"]["slate"]["900"],
    "colorCarouselIconDefault": "rgb(from #B2B9C5 r g b / 0.32)",
    "colorCarouselIconHover": "rgb(from #B2B9C5 r g b / 0.72)",
    "colorCarouselIconSelected": globals["colorScales"]["blue"]["400"],
    "colorCarouselTextPrimary": globals["colorScales"]["white"],
    "colorCategorySelectListBackgroundActive": "rgb(from #1A77CA r g b / 0.06)",
    "colorCategorySelectListBackgroundDefault": globals["colorScales"]["slate"]["100"],
    "colorCategorySelectListBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorCategorySelectListIconActive": globals["colorScales"]["blue"]["500"],
    "colorCategorySelectListIconDefault": globals["colorScales"]["slate"]["600"],
    "colorCategorySelectListIconHover": globals["colorScales"]["white"],
    "colorCategorySelectListTextActive": globals["colorScales"]["blue"]["500"],
    "colorCategorySelectListTextHover": globals["colorScales"]["white"],
    "colorChipBackgroundDanger": globals["colorScales"]["red"]["500"],
    "colorChipBackgroundPrimary": globals["colorScales"]["slate"]["200"],
    "colorChipBackgroundSecondary": globals["colorScales"]["slate"]["300"],
    "colorChipBackgroundSuccessful": globals["colorScales"]["green"]["500"],
    "colorChipBorderPrimary": globals["colorScales"]["slate"]["300"],
    "colorChipFilledBackgroundDanger": globals["colorScales"]["red"]["200"],
    "colorChipFilledBackgroundInfo": globals["colorScales"]["blue"]["200"],
    "colorChipFilledBackgroundPrimary": globals["colorScales"]["navy"]["200"],
    "colorChipFilledBackgroundSecondary": globals["colorScales"]["purple"]["200"],
    "colorChipFilledBackgroundSuccess": globals["colorScales"]["green"]["200"],
    "colorChipFilledBackgroundWarning": globals["colorScales"]["yellow"]["200"],
    "colorChipFilledIconDanger": globals["colorScales"]["red"]["600"],
    "colorChipFilledIconInfo": globals["colorScales"]["blue"]["600"],
    "colorChipFilledIconPrimary": globals["colorScales"]["slate"]["600"],
    "colorChipFilledIconSecondary": globals["colorScales"]["purple"]["600"],
    "colorChipFilledIconSuccess": globals["colorScales"]["green"]["600"],
    "colorChipFilledIconWarning": globals["colorScales"]["yellow"]["600"],
    "colorChipFilledTextDanger": globals["colorScales"]["red"]["600"],
    "colorChipFilledTextInfo": globals["colorScales"]["blue"]["600"],
    "colorChipFilledTextPrimary": globals["colorScales"]["slate"]["600"],
    "colorChipFilledTextSecondary": globals["colorScales"]["purple"]["600"],
    "colorChipFilledTextSuccess": globals["colorScales"]["green"]["600"],
    "colorChipFilledTextWarning": globals["colorScales"]["yellow"]["600"],
    "colorChipIconInverse": globals["colorScales"]["white"],
    "colorChipIconPrimary": globals["colorScales"]["slate"]["800"],
    "colorChipIconWarning": globals["colorScales"]["orange"]["500"],
    "colorChipOutlinedBorderDanger": globals["colorScales"]["red"]["500"],
    "colorChipOutlinedBorderInfo": globals["colorScales"]["blue"]["500"],
    "colorChipOutlinedBorderPrimary": globals["colorScales"]["slate"]["600"],
    "colorChipOutlinedBorderSecondary": globals["colorScales"]["purple"]["500"],
    "colorChipOutlinedBorderSuccess": globals["colorScales"]["green"]["500"],
    "colorChipOutlinedBorderWarning": globals["colorScales"]["yellow"]["500"],
    "colorChipOutlinedIconDanger": globals["colorScales"]["red"]["500"],
    "colorChipOutlinedIconInfo": globals["colorScales"]["blue"]["500"],
    "colorChipOutlinedIconPrimary": globals["colorScales"]["slate"]["500"],
    "colorChipOutlinedIconSecondary": globals["colorScales"]["purple"]["500"],
    "colorChipOutlinedIconSuccess": globals["colorScales"]["green"]["500"],
    "colorChipOutlinedIconWarning": globals["colorScales"]["yellow"]["500"],
    "colorChipOutlinedTextDanger": globals["colorScales"]["red"]["500"],
    "colorChipOutlinedTextInfo": globals["colorScales"]["blue"]["500"],
    "colorChipOutlinedTextPrimary": globals["colorScales"]["slate"]["500"],
    "colorChipOutlinedTextSecondary": globals["colorScales"]["purple"]["500"],
    "colorChipOutlinedTextSuccess": globals["colorScales"]["green"]["500"],
    "colorChipOutlinedTextWarning": globals["colorScales"]["yellow"]["500"],
    "colorChipTextInverse": globals["colorScales"]["white"],
    "colorChipTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorBackground": globals["colorScales"]["slate"]["100"],
    "colorCodeEditorCodeActivelineBackground": "rgb(from #68778D r g b / 0.15)",
    "colorCodeEditorCodeAtomNumberKeywordVariableAttributeQuoteColor": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeBracketCommentColor": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodeCursorBorderLeft": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorCodeCursorBorderRight": globals["colorScales"]["slate"]["300"],
    "colorCodeEditorCodeDefTagBuiltinQualifierHeaderEmColor": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeErrorInvalidcharColor": globals["colorScales"]["red"]["700"],
    "colorCodeEditorCodeFatCursorBackground": globals["colorScales"]["slate"]["300"],
    "colorCodeEditorCodeHint": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorCodeHintActiveBackground": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorCodeHintsBackground": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorCodeIndentationMarkerActiveColor": globals["colorScales"]["slate"]["300"],
    "colorCodeEditorCodeIndentationMarkerColor": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorCodeLinenumberColor": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodeMatchingbracketColor": globals["colorScales"]["slate"]["900"],
    "colorCodeEditorCodePositiveColor": globals["colorScales"]["green"]["800"],
    "colorCodeEditorCodePropertyColor": globals["colorScales"]["orange"]["800"],
    "colorCodeEditorCodePunctuationUnitNegativeColor": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSelectedBackground": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorCodeStringOperatorColor": globals["colorScales"]["green"]["700"],
    "colorCodeEditorCodeSyntaxAtom": globals["colorScales"]["orange"]["600"],
    "colorCodeEditorCodeSyntaxAttributeName": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeSyntaxBool": globals["colorScales"]["orange"]["600"],
    "colorCodeEditorCodeSyntaxBracket": globals["colorScales"]["slate"]["600"],
    "colorCodeEditorCodeSyntaxClassName": globals["colorScales"]["purple"]["600"],
    "colorCodeEditorCodeSyntaxComment": globals["colorScales"]["slate"]["600"],
    "colorCodeEditorCodeSyntaxDeleted": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxDeletedBackground": globals["colorScales"]["red"]["100"],
    "colorCodeEditorCodeSyntaxEmphasis": globals["colorScales"]["grey"]["800"],
    "colorCodeEditorCodeSyntaxEscape": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxHeading": globals["colorScales"]["grey"]["800"],
    "colorCodeEditorCodeSyntaxInvalid": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxKeyword": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxLink": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxMeta": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxName": globals["colorScales"]["green"]["600"],
    "colorCodeEditorCodeSyntaxNumber": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeSyntaxOperator": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeSyntaxPropertyName": globals["colorScales"]["purple"]["600"],
    "colorCodeEditorCodeSyntaxQuote": globals["colorScales"]["green"]["600"],
    "colorCodeEditorCodeSyntaxRegexp": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxSpecialVariableName": globals["colorScales"]["orange"]["600"],
    "colorCodeEditorCodeSyntaxString": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxStrong": globals["colorScales"]["grey"]["800"],
    "colorCodeEditorCodeSyntaxTagName": globals["colorScales"]["green"]["600"],
    "colorCodeEditorCodeSyntaxTypeName": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxTypeOperator": globals["colorScales"]["red"]["600"],
    "colorCodeEditorCodeSyntaxUrl": globals["colorScales"]["blue"]["800"],
    "colorCodeEditorCodeSyntaxVariableName": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeVariable2Variable3String2UrlColor": globals["colorScales"]["blue"]["600"],
    "colorCodeEditorCodeVariableColor": globals["colorScales"]["purple"]["600"],
    "colorCodeEditorForeground": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorSelection": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorSelectionMatch": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorTextDefault": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorTextGutter": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorTextHighlight": globals["colorScales"]["orange"]["800"],
    "colorCodeEditorTextHintHighlight": globals["colorScales"]["green"]["500"],
    "colorCodeEditorToolbarBackground": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorToolbarButtonHover": globals["colorScales"]["slate"]["300"],
    "colorCodeReviewBackgroundDangerDefault": globals["colorScales"]["red"]["200"],
    "colorCodeReviewBackgroundDangerMuted": globals["colorScales"]["red"]["300"],
    "colorCodeReviewBackgroundPrimaryDefault": globals["colorScales"]["slate"]["100"],
    "colorCodeReviewBackgroundPrimaryMuted": globals["colorScales"]["white"],
    "colorCodeReviewBackgroundSuccessDefault": globals["colorScales"]["green"]["200"],
    "colorCodeReviewBackgroundSuccessMuted": globals["colorScales"]["green"]["300"],
    "colorCodeReviewTextDanger": globals["colorScales"]["red"]["700"],
    "colorCodeReviewTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorCodeReviewTextSuccess": globals["colorScales"]["green"]["700"],
    "colorDeprecatedBackgroundWarning": globals["colorScales"]["orange"]["100"],
    "colorDeprecatedBorderWarning": globals["colorScales"]["orange"]["500"],
    "colorDeprecatedIconWarning": globals["colorScales"]["orange"]["400"],
    "colorDeprecatedTextWarning": globals["colorScales"]["orange"]["500"],
    "colorDialogBackgroundPrimary": globals["colorScales"]["white"],
    "colorDialogBackgroundSecondaryDefault": globals["colorScales"]["slate"]["100"],
    "colorDialogBackgroundSecondaryUpsell": "linear-gradient(95deg, rgb(from #1A77CA r g b / 0.6) 0%, rgb(from #895ED3 r g b / 0.6) 100%)",
    "colorDialogHelpPanelText": globals["colorScales"]["white"],
    "colorFormLegendBackgroundHover": globals["colorScales"]["slate"]["200"],
    "colorFormLegendBackgroundRest": globals["colorScales"]["slate"]["100"],
    "colorFreezeStatusBorder": globals["colorScales"]["blue"]["300"],
    "colorFreezeStatusIcon": globals["colorScales"]["blue"]["700"],
    "colorHealthStatusBackgroundExecuting": globals["colorScales"]["blue"]["500"],
    "colorHealthStatusBackgroundFailure": globals["colorScales"]["red"]["500"],
    "colorHealthStatusBackgroundNeutral": globals["colorScales"]["slate"]["200"],
    "colorHealthStatusBackgroundSuccess": globals["colorScales"]["green"]["500"],
    "colorHealthStatusBackgroundWarning": globals["colorScales"]["yellow"]["500"],
    "colorHealthStatusIconDefault": globals["colorScales"]["white"],
    "colorHealthStatusIconInverse": globals["colorScales"]["slate"]["700"],
    "colorIconDanger": globals["colorScales"]["red"]["500"],
    "colorIconDisabled": globals["colorScales"]["slate"]["300"],
    "colorIconFeature": globals["colorScales"]["purple"]["400"],
    "colorIconInfo": globals["colorScales"]["slate"]["600"],
    "colorIconInversePrimary": globals["colorScales"]["white"],
    "colorIconInverseSecondary": globals["colorScales"]["slate"]["200"],
    "colorIconLinkDefault": globals["colorScales"]["slate"]["700"],
    "colorIconLinkHover": globals["colorScales"]["slate"]["500"],
    "colorIconPrimary": globals["colorScales"]["slate"]["800"],
    "colorIconSecondary": globals["colorScales"]["slate"]["600"],
    "colorIconSelected": globals["colorScales"]["slate"]["800"],
    "colorIconSuccess": globals["colorScales"]["green"]["500"],
    "colorIconTertiary": globals["colorScales"]["slate"]["400"],
    "colorIconWarning": globals["colorScales"]["yellow"]["400"],
    "colorLifecycleBackgroundPrimary": globals["colorScales"]["slate"]["400"],
    "colorLifecycleBorderDefault": globals["colorScales"]["slate"]["600"],
    "colorLifecycleIconPrimary": globals["colorScales"]["white"],
    "colorLifecycleTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorMenuListBackgroundActive": globals["colorScales"]["slate"]["200"],
    "colorMenuListBackgroundDefault": globals["colorScales"]["white"],
    "colorMenuListBackgroundHover": globals["colorScales"]["slate"]["100"],
    "colorMenuListBorderPrimary": globals["colorScales"]["slate"]["200"],
    "colorMenuListIconPrimary": globals["colorScales"]["slate"]["600"],
    "colorMenuListTextHighlight": globals["colorScales"]["slate"]["900"],
    "colorMenuListTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorMenuListTextSecondary": globals["colorScales"]["slate"]["600"],
    "colorNavButtonBackgroundActive": globals["colorScales"]["slate"]["200"],
    "colorNavButtonBackgroundDefault": "rgb(from #16191F r g b / 0)",
    "colorNavButtonBackgroundHover": globals["colorScales"]["slate"]["200"],
    "colorNavButtonBackgroundPressed": globals["colorScales"]["slate"]["300"],
    "colorNavButtonIconActive": globals["colorScales"]["slate"]["200"],
    "colorNavButtonIconDefault": globals["colorScales"]["slate"]["800"],
    "colorNavButtonIconHover": globals["colorScales"]["slate"]["200"],
    "colorNavButtonIconPressed": globals["colorScales"]["slate"]["200"],
    "colorNavListBackgroundActive": globals["colorScales"]["slate"]["100"],
    "colorNavListBackgroundDefault": "rgb(from #F5F6F8 r g b / 0)",
    "colorNavListBackgroundHover": globals["colorScales"]["slate"]["700"],
    "colorNavListIconActive": globals["colorScales"]["slate"]["600"],
    "colorNavListIconDefault": globals["colorScales"]["slate"]["800"],
    "colorNavListTextActive": globals["colorScales"]["slate"]["800"],
    "colorNavListTextDefault": globals["colorScales"]["slate"]["800"],
    "colorNavListTextHover": globals["colorScales"]["white"],
    "colorNavTabBackgroundActive": "rgb(from #FFFFFF r g b / 0)",
    "colorNavTabBackgroundHover": globals["colorScales"]["slate"]["100"],
    "colorNavTabBorderPrimary": globals["colorScales"]["slate"]["800"],
    "colorNavTabIconActive": globals["colorScales"]["slate"]["600"],
    "colorNavTabIconDefault": globals["colorScales"]["slate"]["800"],
    "colorNavTabIconHover": globals["colorScales"]["slate"]["600"],
    "colorNavTabTextActive": globals["colorScales"]["slate"]["700"],
    "colorNavTabTextDefault": globals["colorScales"]["slate"]["800"],
    "colorNavTabTextHover": globals["colorScales"]["slate"]["500"],
    "colorOverlayPrimary": "rgb(from #282F38 r g b / 0.56)",
    "colorOverlaySecondary": "rgb(from #000000 r g b / 0.31)",
    "colorPaginationBackgroundActive": globals["colorScales"]["slate"]["800"],
    "colorPaginationBackgroundDefault": globals["colorScales"]["white"],
    "colorPaginationBackgroundDisabled": globals["colorScales"]["white"],
    "colorPaginationBackgroundHover": globals["colorScales"]["slate"]["400"],
    "colorPaginationIconActive": globals["colorScales"]["white"],
    "colorPaginationIconDefault": globals["colorScales"]["slate"]["800"],
    "colorPaginationIconDisabled": globals["colorScales"]["slate"]["400"],
    "colorPaginationIconHover": globals["colorScales"]["white"],
    "colorPaginationTextActive": globals["colorScales"]["white"],
    "colorPaginationTextDefault": globals["colorScales"]["slate"]["800"],
    "colorPaginationTextDisabled": globals["colorScales"]["slate"]["400"],
    "colorPaginationTextHover": globals["colorScales"]["white"],
    "colorParallelChipBackground": globals["colorScales"]["slate"]["500"],
    "colorParallelChipIcon": globals["colorScales"]["white"],
    "colorPopoverBackgroundPrimary": globals["colorScales"]["white"],
    "colorPopoverBackgroundSecondary": globals["colorScales"]["slate"]["100"],
    "colorPopoverInfoCircleBackgroundDefault": globals["colorScales"]["slate"]["200"],
    "colorPopoverInfoCircleBackgroundHover": globals["colorScales"]["slate"]["500"],
    "colorPopoverInfoCircleTextDefault": globals["colorScales"]["slate"]["600"],
    "colorPopoverInfoCircleTextHover": globals["colorScales"]["slate"]["100"],
    "colorPortalCardBackground": globals["colorScales"]["white"],
    "colorPortalCardContentDisabled": globals["colorScales"]["grey"]["500"],
    "colorPortalCardContentText": globals["colorScales"]["grey"]["600"],
    "colorPortalChipBackground": globals["colorScales"]["grey"]["200"],
    "colorPortalLinkTextHover": globals["colorScales"]["blue"]["600"],
    "colorPortalLogoBackground": "transparent",
    "colorPortalPopoverBackground": globals["colorScales"]["white"],
    "colorProcessContainerBackgroundSelected": globals["colorScales"]["slate"]["100"],
    "colorProcessContainerBorderSelected": globals["colorScales"]["slate"]["400"],
    "colorProcessStepBackgroundErrorPrimary": globals["colorScales"]["red"]["100"],
    "colorProcessStepBackgroundErrorSecondary": globals["colorScales"]["red"]["300"],
    "colorProcessStepBackgroundErrorSelected": globals["colorScales"]["red"]["200"],
    "colorProcessStepBackgroundHoverError": globals["colorScales"]["red"]["200"],
    "colorProcessStepBackgroundHoverPrimary": globals["colorScales"]["slate"]["100"],
    "colorProcessStepBackgroundHoverSecondary": globals["colorScales"]["slate"]["200"],
    "colorProcessStepBackgroundHoverTertiary": globals["colorScales"]["slate"]["100"],
    "colorProcessStepBackgroundHoverWarning": globals["colorScales"]["orange"]["200"],
    "colorProcessStepBackgroundPrimaryDefault": globals["colorScales"]["white"],
    "colorProcessStepBackgroundPrimarySelected": globals["colorScales"]["blue"]["100"],
    "colorProcessStepBackgroundSecondaryDefault": globals["colorScales"]["slate"]["100"],
    "colorProcessStepBackgroundWarningDefault": globals["colorScales"]["orange"]["100"],
    "colorProcessStepBackgroundWarningSecondary": globals["colorScales"]["orange"]["300"],
    "colorProcessStepBackgroundWarningSelected": globals["colorScales"]["orange"]["200"],
    "colorProcessStepBorderDefault": globals["colorScales"]["slate"]["200"],
    "colorProcessStepBorderDisabled": globals["colorScales"]["slate"]["200"],
    "colorProcessStepBorderErrorDefault": globals["colorScales"]["red"]["300"],
    "colorProcessStepBorderErrorHover": globals["colorScales"]["red"]["400"],
    "colorProcessStepBorderErrorSelected": globals["colorScales"]["red"]["500"],
    "colorProcessStepBorderHover": globals["colorScales"]["slate"]["300"],
    "colorProcessStepBorderSelected": globals["colorScales"]["slate"]["400"],
    "colorProcessStepBorderWarningDefault": globals["colorScales"]["orange"]["300"],
    "colorProcessStepBorderWarningHover": globals["colorScales"]["orange"]["400"],
    "colorProcessStepBorderWarningSelected": globals["colorScales"]["orange"]["500"],
    "colorProcessStepIconDefault": globals["colorScales"]["slate"]["800"],
    "colorProcessStepIconErrorPrimary": globals["colorScales"]["red"]["500"],
    "colorProcessStepIconErrorSecondary": globals["colorScales"]["red"]["600"],
    "colorProcessStepIconWarningPrimary": globals["colorScales"]["orange"]["400"],
    "colorProcessStepIconWarningSecondary": globals["colorScales"]["orange"]["500"],
    "colorProcessStepTextDisabled": globals["colorScales"]["slate"]["400"],
    "colorProcessWrapperBackgroundPrimary": globals["colorScales"]["slate"]["100"],
    "colorProcessWrapperBackgroundSecondary": globals["colorScales"]["slate"]["200"],
    "colorProgressBackgroundLinear": globals["colorScales"]["slate"]["200"],
    "colorProgressBackgroundPrimary": globals["colorScales"]["slate"]["500"],
    "colorProgressBackgroundSecondary": globals["colorScales"]["slate"]["200"],
    "colorProgressForegroundCircular": globals["colorScales"]["slate"]["500"],
    "colorProgressForegroundLinear": globals["colorScales"]["slate"]["500"],
    "colorProgressTextInfo": globals["colorScales"]["slate"]["500"],
    "colorScrollbarBackground": "rgb(from #FFFFFF r g b / 0)",
    "colorScrollbarHandle": globals["colorScales"]["slate"]["400"],
    "colorSearchBackgroundNotice": globals["colorScales"]["slate"]["100"],
    "colorSearchBackgroundResultHover": globals["colorScales"]["slate"]["100"],
    "colorSearchBackgroundResultPressed": globals["colorScales"]["slate"]["200"],
    "colorSpaceSwitcherBackgroundDefault": "rgb(from #DEE1E6 r g b / 0.32)",
    "colorSpaceSwitcherBackgroundHover": globals["colorScales"]["slate"]["500"],
    "colorSpaceSwitcherBackgroundPressed": globals["colorScales"]["slate"]["500"],
    "colorSpaceSwitcherBorderPrimary": "rgb(from #16191F r g b / 0.16)",
    "colorSpaceSwitcherIconDefault": globals["colorScales"]["slate"]["600"],
    "colorSpaceSwitcherTextDefault": globals["colorScales"]["slate"]["600"],
    "colorSpaceSwitcherTextHover": globals["colorScales"]["white"],
    "colorSpaceSwitcherTextPressed": globals["colorScales"]["white"],
    "colorStatusBadgeBackgroundHealthy": globals["colorScales"]["green"]["500"],
    "colorStatusBadgeBackgroundNeutral": globals["colorScales"]["slate"]["200"],
    "colorStatusBadgeBackgroundUnhealthy": globals["colorScales"]["red"]["500"],
    "colorStatusBadgeBackgroundWarning": globals["colorScales"]["yellow"]["500"],
    "colorStatusBadgeIconDefault": globals["colorScales"]["white"],
    "colorStatusBadgeIconInverse": globals["colorScales"]["slate"]["700"],
    "colorStatusBadgeTextInverse": globals["colorScales"]["slate"]["700"],
    "colorStatusBadgeTextPrimary": globals["colorScales"]["white"],
    "colorSwitchBackgroundOffDefault": globals["colorScales"]["slate"]["300"],
    "colorSwitchBackgroundOffDisabled": globals["colorScales"]["slate"]["200"],
    "colorSwitchBackgroundOnDefault": globals["colorScales"]["blue"]["300"],
    "colorSwitchBackgroundOnDisabled": globals["colorScales"]["blue"]["200"],
    "colorSwitchForegroundOffDefault": globals["colorScales"]["slate"]["100"],
    "colorSwitchForegroundOffDisabled": globals["colorScales"]["slate"]["300"],
    "colorSwitchForegroundOnDefault": globals["colorScales"]["blue"]["500"],
    "colorSwitchForegroundOnDisabled": globals["colorScales"]["blue"]["300"],
    "colorSwitchIconActive": globals["colorScales"]["slate"]["900"],
    "colorSwitchOverlayOff": "rgb(from #B2B9C5 r g b / 0.16)",
    "colorSwitchOverlayOn": "rgb(from #87BFEC r g b / 0.16)",
    "colorTableBackgroundDangerDefault": globals["colorScales"]["red"]["200"],
    "colorTableBackgroundDangerHover": "rgb(from #FF9F9F r g b / 0.75)",
    "colorTableBackgroundSuccessDefault": globals["colorScales"]["green"]["200"],
    "colorTableBackgroundSuccessHover": "rgb(from #5ECD9E r g b / 0.75)",
    "colorTableHeaderBackground": "rgb(from #F5F6F8 r g b / 0.3)",
    "colorTableTextDanger": globals["colorScales"]["red"]["700"],
    "colorTagBackground": globals["colorScales"]["slate"]["100"],
    "colorTagText": globals["colorScales"]["slate"]["700"],
    "colorTextDanger": globals["colorScales"]["red"]["500"],
    "colorTextDisabled": globals["colorScales"]["slate"]["300"],
    "colorTextFeature": globals["colorScales"]["purple"]["500"],
    "colorTextFieldBorderActive": globals["colorScales"]["slate"]["900"],
    "colorTextFieldBorderDanger": globals["colorScales"]["red"]["500"],
    "colorTextFieldBorderDefault": globals["colorScales"]["slate"]["300"],
    "colorTextFieldBorderDisabled": globals["colorScales"]["slate"]["300"],
    "colorTextFieldBorderHover": globals["colorScales"]["slate"]["500"],
    "colorTextFieldIconDisabled": globals["colorScales"]["slate"]["300"],
    "colorTextFieldIconPrimary": globals["colorScales"]["slate"]["700"],
    "colorTextFieldTextDanger": globals["colorScales"]["red"]["500"],
    "colorTextFieldTextDisabled": globals["colorScales"]["slate"]["300"],
    "colorTextFieldTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorTextFieldTextSecondary": globals["colorScales"]["slate"]["500"],
    "colorTextFieldTextSelected": globals["colorScales"]["slate"]["900"],
    "colorTextInfo": globals["colorScales"]["slate"]["900"],
    "colorTextInversePrimary": globals["colorScales"]["white"],
    "colorTextInverseSecondary": globals["colorScales"]["slate"]["200"],
    "colorTextLinkDefault": globals["colorScales"]["slate"]["900"],
    "colorTextLinkHover": globals["colorScales"]["slate"]["700"],
    "colorTextPrimary": globals["colorScales"]["slate"]["800"],
    "colorTextSecondary": globals["colorScales"]["slate"]["600"],
    "colorTextSelected": globals["colorScales"]["slate"]["800"],
    "colorTextSuccess": globals["colorScales"]["green"]["500"],
    "colorTextTertiary": globals["colorScales"]["slate"]["500"],
    "colorTextWarning": globals["colorScales"]["yellow"]["400"],
    "shadowDrawer": "-4px 0 16px 0 rgba(0,0,0,0.08), -12px 4px 24px -4px rgba(0,0,0,0.1)",
    "shadowExtraSmall": "0 1px 8px 0 rgba(0,0,0,0.02), 0 1px 2px 0 rgba(0,0,0,0.06)",
    "shadowFocused": "0 0 0 1px rgb(26,119,202), 0 0 0 5px rgba(26,119,202,0.32)",
    "shadowFocusedInset": "inset 0 0 0 4px rgba(26,119,202,0.32)",
    "shadowLarge": "0 2px 6px 0 rgba(0,0,0,0.1), 0 14px 32px -4px rgba(0,0,0,0.12)",
    "shadowLayoutPrimary": "-2px -2px 6px 0 rgba(0,0,0,0.06)",
    "shadowMedium": "0 1px 4px 0 rgba(0,0,0,0.04), 0 6px 12px 0 rgba(0,0,0,0.1)",
    "shadowSmall": "0 1px 1px 0 rgba(0,0,0,0.12), 0 1px 8px 0 rgba(0,0,0,0.06)"
};